import React, { useState, useEffect, useCallback } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from '@mui/material';
import { Delete as DeleteIcon, Send as SendIcon } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-final-form';

import { Content } from '../layout';
import { Radio, TextField } from '../common/Fields';
import { targets } from './types';

import {
  getNotice,
  submitNotice,
  updateNotice,
  deleteNotice,
  fetchNoticeMacros,
} from '../../actions';

const NoticeForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { notice } = useSelector((state) => state.notice);
  const noticeMacros = useSelector(
    (state) => state.noticeMacro.noticeMacros.rows
  );
  const { noticeMacro } = useSelector((state) => state.noticeMacro);

  const [target, setTarget] = useState('0');
  const [isUrgent, setIsUrgent] = useState(false);
  const [NoticeMacroId, setNoticeMacroId] = useState();
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    dispatch(fetchNoticeMacros());
    if (id) {
      dispatch(getNotice(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (notice) {
      setTarget(String(notice.target));
      setIsUrgent(notice.isUrgent);
      setNoticeMacroId(notice.NoticeMacro.id);
      setSubject(notice.NoticeMacro.subject);
      setContent(notice.NoticeMacro.content);
    }
  }, [notice]);

  useEffect(() => {
    if (noticeMacro) {
      console.log('noticeMacro', noticeMacro);
      setSubject(noticeMacro.subject);
      setContent(noticeMacro.content);
    }
  }, [noticeMacro]);

  const handleChangeTarget = (event) => {
    setTarget(String(event.target.value));
  };

  const handleChangeIsUrgent = (event) => {
    setIsUrgent(JSON.parse(event.target.value));
  };

  const handleChangeNoticeMacro = (event) => {
    event.preventDefault();
    const targetValue = Number(event.target.value);
    setNoticeMacroId(targetValue);
    // console.log("messageMacros", messageMacros);
    const { subject, content } = noticeMacros.find(
      (macro) => macro.id === targetValue
    );
    setSubject(subject);
    setContent(content);
  };

  const onSubmit = useCallback(
    (notice) => {
      console.log('notice on submit', notice);
      if (id) {
        dispatch(updateNotice({ notice, id }, navigate));
      } else {
        dispatch(submitNotice({ notice }, navigate));
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteNotice({ id }, navigate));
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        target,
        isUrgent,
        NoticeMacroId,
      }}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      render={({ submitError, handleSubmit, submitting, pristine, values }) => (
        <Content>
          <form onSubmit={handleSubmit} style={{ flexGrow: 1 }}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  공지사항
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <Radio
                      label="대상"
                      name="target"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={targets}
                      dataKey="id"
                      dataValue="name"
                      onChange={handleChangeTarget}
                      // checkedValue={target}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Radio
                      label="긴급 여부"
                      name="isUrgent"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={[
                        { id: false, name: '일반' },
                        { id: true, name: '긴급' },
                      ]}
                      dataKey="id"
                      dataValue="name"
                      onChange={handleChangeIsUrgent}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Radio
                      label="매크로"
                      name="NoticeMacroId"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={noticeMacros}
                      dataKey="id"
                      dataValue="macroId"
                      // helperText={helperText}
                      onChange={handleChangeNoticeMacro}
                      // checkedValue={messageMacroId}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="subject"
                      type="text"
                      label="제목"
                      value={subject}
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="content"
                      type="text"
                      label="내용"
                      value={content}
                      readOnly
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default NoticeForm;
